<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="홍보자료실"
      subtitle="홍보자료실"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Loading v-show="isLoading" />

      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">홍보자료실<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="scbd co-default">
          <!-- head -->
          <div class="head">
            <div class="nav">
              <ul>
                <li>
                  <a
                    href="javascript:;"
                    class="searchFormToggle gbg"
                    @click="toggleSearchForm"
                    ><span>검색</span>
                    <i
                      class="sp-ico"
                      :class="{ 'is-open': isSearchFormOpen }"
                    ></i
                  ></a>
                </li>
              </ul>
            </div>
            <div class="searchForm" :class="{ on: isSearchFormOpen }">
              <form
                name="search_form"
                method="get"
                action="https://www.cokolab.com/bbs_shop/list.htm"
                @submit.prevent="performSearch"
              >
                <input type="hidden" name="list_mode" value="board" />
                <input type="hidden" name="cate_sub_idx" value="0" />
                <input type="hidden" name="search_first_subject" value="" />
                <input type="hidden" name="board_code" value="notice" />
                <input type="hidden" name="me_popup" value="0" />
                <input type="hidden" name="auto_frame" value="" />
                <fieldset>
                  <legend class="blind">게시물 검색</legend>
                  <input
                    type="text"
                    name="search_key"
                    maxlength="30"
                    v-model="searchQuery"
                    placeholder="검색어"
                  />
                  <button type="submit" class="sp-ico">검색</button>
                </fieldset>
              </form>
            </div>
          </div>
          <!-- // head -->

          <!-- body -->
          <div class="list_board">
            <table cellspacing="0" border="0">
              <caption>
                List of articles
              </caption>
              <thead>
                <tr>
                  <th scope="col" class="no">번호</th>
                  <th scope="col" class="subject">제목</th>
                  <th scope="col" class="name">작성자</th>
                  <th scope="col" class="date">작성일</th>
                  <th scope="col" class="date">첨부파일</th>
                </tr>
              </thead>

              <tbody>
                <template v-if="!listLoading">
                  <tr v-if="!pressList || pressList.length === 0">
                    <td colspan="4" style="text-align: center">
                      게시글이 없습니다.
                    </td>
                  </tr>
                  <tr v-for="(item, index) in pressList" :key="item.SK" v-else>
                    <td class="no">
                      {{ (currentPage - 1) * pageSize + (index + 1) }}
                    </td>
                    <td class="subject">
                      <router-link
                        :to="{
                          name: USER_ROUTES.Press.Content.Name,
                          params: { id: item.SK },
                        }"
                      >
                        <span>{{ item.title }}</span>
                      </router-link>
                    </td>
                    <td class="name inline">{{ item.author }}</td>
                    <td class="date inline">
                      {{ common.getYYYYMMDD2(item.createdDate) }}
                    </td>
                    <td>
                      <n-button
                        v-if="item.attached_file_drive_id"
                        @click="onFileDonwload(item)"
                        >다운로드</n-button
                      >
                      <span v-else>없음</span>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <td colspan="4" style="text-align: center">
                    게시글 조회 중입니다.
                  </td>
                </template>
              </tbody>
            </table>
          </div>
          <div
            v-if="pressList.length > 0"
            class="pagination-controls"
            style="margin-top: 15px; text-align: center"
          >
            <n-button
              @click="wrappedGoToPreviousPage"
              :disabled="currentPage === 1"
              style="margin-right: 8px"
            >
              이전 페이지
            </n-button>
            <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
            <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage">
              다음 페이지
            </n-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, watch } from "vue";

import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { getCallable, makeCallApiParam } from "@/config/env";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { Board } from "@/model/board";

import { NButton, useMessage, useNotification, useDialog } from "naive-ui";
import { usePagination } from "@/composables/usePagination";
import { useDownload } from "@/composables/useDownload";
const { downloadNormalFile } = useDownload();

const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const getCallApiCallable = getCallable("callApi");
const getPresses = "getBoards";

const isLoading = ref<boolean>(false);
const searchQuery = ref(""); // 검색어 상태 추가
const pageSize = 10; // 페이지 크기를 상수로 정의
const isSearchFormOpen = ref(false); // 검색창 표시 여부 상태

const {
  paginatedItems: pressList,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshNotices,
} = usePagination<Board, { searchKey?: string; searchValue?: string }>(
  async (params) =>
    getCallApiCallable(
      makeCallApiParam(getPresses, {
        ...params,
        searchKey: "title",
        searchValue: searchQuery.value,
        type: constant.boardType.PRESS,
      })
    ),
  pageSize
);

async function wrappedRefreshPresses() {
  await composableRefreshNotices();
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}
const toggleSearchForm = () => {
  isSearchFormOpen.value = !isSearchFormOpen.value;
};

function performSearch() {
  // 검색 실행 시 첫 페이지부터 다시 로드하도록 refreshData 호출
  composableRefreshNotices(true); // true를 전달하여 페이지를 1로 리셋
}

async function onFileDonwload(row: Board) {
  isLoading.value = true;
  await downloadNormalFile(row.attached_file_drive_id, row.attached_file_name);
  isLoading.value = false;
}

onMounted(() => {
  wrappedRefreshPresses();
});
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");

  background-size: 300px 250px;
  display: inline-block; /* transform 및 transition 적용을 위해 추가 */
}
.scbd .sp-ico.is-open {
  transform: rotate(180deg); /* 검색창 열렸을 때 아이콘 180도 회전 */
}
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub1 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub1 {
  background: #f5f5f5;
  padding: 100px 10px;
  text-align: center;
  line-height: 1.7em;
}

.list_board table {
  width: 100%; /* 테이블 전체 너비 사용 */
  table-layout: fixed; /* 헤더 너비 기준으로 컬럼 너비 고정 */
  border-collapse: collapse; /* 테두리 선 겹침 처리 */
}

.list_board table th,
.list_board table td {
  padding: 10px 8px; /* 셀 내부 여백 */
  border-bottom: 1px solid #e0e0e0; /* 셀 하단 구분선 */
  vertical-align: middle; /* 셀 내용 수직 가운데 정렬 */
}

.list_board table th {
  background-color: #f9f9f9; /* 헤더 배경색 */
  font-weight: 600; /* 헤더 폰트 굵기 */
  text-align: center; /* 헤더 텍스트 가운데 정렬 */
}

/* 컬럼별 너비 설정 */
.list_board table th.no,
.list_board table td.no {
  width: 10%;
}

.list_board table th.subject,
.list_board table td.subject {
  width: 55%; /* 제목 컬럼을 더 넓게 */
}

.list_board table th.name,
.list_board table td.name {
  width: 15%;
}

.list_board table th.date,
.list_board table td.date {
  width: 20%;
}

/* tbody 셀 텍스트 정렬 */
.list_board table tbody td {
  text-align: center; /* 기본적으로 가운데 정렬 */
}
.list_board table tbody td.subject {
  text-align: left; /* 제목 컬럼만 좌측 정렬 */
  padding-left: 50px !important;
}
.paginate a.disabled {
  pointer-events: none; /* 클릭 비활성화 */
  opacity: 0.5; /* 흐릿하게 표시 */
}
</style>
